import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { guardarRutaDestino } from '../utils/return-url.util';

/**
 * Protege las rutas del área autenticada.
 *
 * Antes de desviar al login guarda la ruta solicitada, para que el usuario
 * aterrice en ella al terminar de autenticarse en vez de en `/app/home`. Sin
 * esto, cualquier deep link —el botón de los correos de turnado, un enlace
 * compartido por chat— perdería su destino justo en el caso más frecuente:
 * abrirlo sin una sesión activa.
 *
 * Ver `specs/spec-047-return-url-deep-links-autenticados.md`.
 */
export const authGuard: CanActivateFn = (_ruta, estado) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  guardarRutaDestino(estado.url);

  return router.createUrlTree(['/auth/login']);
};
